import { createAction } from 'redux-actions'

export const indicatorRequest = createAction('indicators/INDICATOR_REQUEST')
export const indicatorResponse = createAction('indicators/INDICATOR_RESPONSE')
